import Pricing from '@/apps/upgrade/Pricing.vue';
import { requireSeeker } from '../guards/authGuards';

const upgradeRoutes = [
  {
    path: '/upgrade/pricing',
    name: 'upgrade-pricing',
    component: Pricing,
    beforeEnter: requireSeeker,
  },
  {
    path: '/upgrade',
    redirect: (to) => ({ name: 'upgrade-pricing', query: to.query }),
  },
];

export default upgradeRoutes;
